import React, { useState } from 'react';

/**
 * Counter Component
 * A simple interactive component demonstrating React state management
 */
function Counter({ initialCount = 0 }) {
    const [count, setCount] = useState(initialCount);

    const buttonStyle = {
        padding: '10px 20px',
        margin: '5px',
        fontSize: '16px',
        cursor: 'pointer',
        backgroundColor: '#15171A',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        transition: 'background-color 0.2s'
    };

    const countStyle = {
        fontSize: '32px',
        fontWeight: 'bold',
        margin: '20px 0',
        color: '#15171A'
    };

    return (
        <div style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '8px' }}>
            <div style={countStyle}>Count: {count}</div>
            <div>
                <button 
                    style={buttonStyle}
                    onClick={() => setCount(count - 1)}
                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(17,24,39,0.95)'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(17,24,39,0.95)'}
                >
                    Decrease
                </button>
                <button 
                    style={buttonStyle}
                    onClick={() => setCount(initialCount)}
                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(17,24,39,0.95)'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(17,24,39,0.95)'}
                >
                    Reset
                </button>
                <button 
                    style={buttonStyle}
                    onClick={() => setCount(count + 1)}
                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(17,24,39,0.95)'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(17,24,39,0.95)'}
                >
                    Increase
                </button>
            </div>
        </div>
    );
}

export default Counter;
